// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ZM2vr","title":"Header_title__3UXHz","side":"Header_side__31_s9"};